export default __webpack_public_path__ + "static/media/order-new-card-error.0883a728.svg";